import { PaletteOptions } from '@mui/material/styles/createPalette';

export const palette: PaletteOptions = {
  primary: {
    main: '#142A4D',
    light: '#4F5F7A',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#72A5CD',
    light: '#95BCDA',
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#92CE50',
    light: '#C9E7A8',
  },
  error: {
    main: '#CE5050',
    light: '#E7A8A8',
  },
  warning: {
    main: '#EECA4B',
    light: '#F7E5A6',
  },
  info: {
    main: '#0058E9',
    light: '#8DB4F5',
  },
  text: {
    primary: '#142A4D',
    secondary: '#8994A6',
    disabled: '#DADADA',
  },
  background: {
    default: '#F3F4F6',
    paper: '#FFFFFF',
    navbar: '#E7E9ED',
  },
};
